export const environment = {
  envName: 'test',
  production: false,
  apiBaseUrl: 'https://ares-api-test.azure.chevron.com/api',
  appInsightsConnectionString: 'InstrumentationKey=PLACEHOLDER_TEST;...',  // replace with test App Insights connection string
  /** Chevron Entra ID tenant — used to distinguish internal vs. external users. */
  chevronTenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
  msal: {
    auth: {
      clientId: '7f06aa5f-cde2-4a72-8d22-92b8c5c572ec',
      authority: 'https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
      redirectUri: `${location.origin}/auth`,
      postLogoutRedirectUri: location.origin,
    },
    api: {
      scopeUri: 'api://98cb2c1f-9da9-4f16-a204-c2686fc0be09/user_impersonation',
    },
  },
  okta: {
    authority: 'https://cvxportal-nonprod.oktapreview.com/oauth2/default',
    clientId: '0oa11xu5vrlGaZLIk1d8',
    redirectUri: `${location.origin}/auth`,
    scopes: 'openid profile email offline_access groups',
  },
};
